export const NEW_REPORT_ON_CASE_FILE_REDUX_PROP = 'newReportOnCasefile';
export const NEW_REPORT_ON_CASE_FILE_REDUX_VALUE = 'caseFile';
